<!-- <footer class="text-center text-white w-100" style="background: var(--color-3)">
  <div class="container pt-4">
    <section class="mb-4">
      <a class="btn btn-link btn-floating btn-lg text-white m-1" href="#!" role="button"
        data-mdb-ripple-color="light"><i class="fab fa-facebook-f"></i></a>

      <a class="btn btn-link btn-floating btn-lg text-white m-1" href="#!" role="button"
        data-mdb-ripple-color="light"><i class="fab fa-twitter"></i></a>

      <a class="btn btn-link btn-floating btn-lg text-white m-1" href="#!" role="button"
        data-mdb-ripple-color="light"><i class="fab fa-google"></i></a>

      <a class="btn btn-link btn-floating btn-lg text-white m-1" href="#!" role="button"
        data-mdb-ripple-color="light"><i class="fab fa-instagram"></i></a>

      <a class="btn btn-link btn-floating btn-lg text-white m-1" href="#!" role="button"
        data-mdb-ripple-color="light"><i class="fab fa-linkedin"></i></a>
      <a class="btn btn-link btn-floating btn-lg text-white m-1" href="#!" role="button"
        data-mdb-ripple-color="light"><i class="fab fa-github"></i></a>
    </section>
  </div>

  <div class="text-center text-white p-3" style="background-color: rgba(0, 0, 0, 0.2)">
    © 2023 :
    <span class="text-white">{{ "Saudi Business Center" | translator }}</span>
  </div>
</footer> -->
<!-- NEW -->
<!-- <footer class="footer-bg">
  <div class="container max-width">
    <div class="foot-flex">
      <div class="d-flex align-items-center">
        <span class="foot-nav">خريطة الموقع</span>
        <span class="foot-nav">سياسية الخصوصية</span>
        <span class="foot-nav">شروط الاستخدام</span>
      </div>
      <div class="p-3">
        <span class="copy-right">© 2023 المركز السعودي للأعمال جميع الحقوق محفوظة</span>
      </div>
      <div class="d-flex align-items-center">
        <section>
          <a class="foot-a">
            <img class="foot-icone" src="../../../assets/v-4-icone/Vector(Stroke).svg" alt="loading" />
          </a>
          <a class="foot-a">
            <img class="foot-icone" src="../../../assets/v-4-icone/Vector(7).svg" alt="loading" />
          </a>
          <a class="foot-a">
            <img class="foot-icone" src="../../../assets/v-4-icone/Vector(6).svg" alt="loading" />
          </a>
          <a class="foot-a">
            <img class="foot-icone" src="../../../assets/v-4-icone/Vector(8).svg" alt="loading" />
          </a>
        </section>
      </div>
    </div>
  </div>
</footer> -->







<footer class="section text-white pt-lg-5 pt-0 v4-footer-bg">
  <div class="container">
  <div class="row pb-3">
  <div class="col-md-12">
  <div class="row Contact-footer py-3 p-lg-0 justify-content-center">
  
  <div class="mb-2 col-lg-3 col-md-6 col-sm-6 col-12 p-footer-small p-0 custom-flex">
    <div class="media">
      <div class="w-box-icon">
        <img src="../assets/icons/Icon-010.svg" class="" alt="">
      </div>
      <div class="media-body">
        <span>من داخل المملكة</span>
        <strong class="d-block mb-1 color-1 "><a class="color-1" href="tel:199080">199080</a></strong>
      </div>
    </div>
  </div>
  <!-- <div class="mb-2 col-lg-3 col-md-6 col-sm-6 col-12 p-footer-small p-0 custom-flex">
    <div class="media">
    
      <div class="w-box-icon">
        <img src="../assets/icons/Icon-09.svg" class="" alt="">
      </div>
      <div class="media-body">
        <span>من خارج المملكة</span>
        <strong class="d-block mb-1 color-1"><a [style.--background]="background" class="color-1" href="tel:00966118387888">00966118387888</a></strong>
      </div>
    </div>
  </div> -->
  <!-- <div class="mb-2 col-lg-3 col-md-6 col-sm-6 col-12 p-footer-small p-0 custom-flex">
    <div class="media">
      <div class="w-box-icon">
        <img src="../assets/icons/104-2.svg" class="" alt="">
      </div>
      <div class="media-body">
        <span>تويتر العناية بالعملاء</span>
        <strong class="d-block mb-1 color-1"><a [style.--background]="background" class="color-1 d-inline-block" style="direction: ltr;" rel="noopener" href="https://twitter.com/BCgov_Care" target="_blank">@BCgov_Care</a></strong>
        
      </div>
    </div>
  </div> -->
  <div *ngIf="isLoggedIn" class="mb-2 col-lg-3 col-md-6 col-sm-6 col-12 p-footer-small p-0 custom-flex">
    <div class="media">
      <div class="w-box-icon">
        <img src="../assets/icons/Icon-08.svg" class="" alt="">
      </div>
      <div class="media-body">
        <span>البريد الإلكتروني</span>
        <strong class="d-block mb-1 color-1"><a class="color-1" href="mailto:kgatecare@bc.gov.sa">{{"kgatecare@bc.gov.sa"}}</a></strong>
      </div>
    </div>
  </div>

  </div>
</div>

</div>
</div>

  
  <div class="footer-line-bootom">
    <div class="container">
        <div class="row">
          <div class="col-md-8 col-lg-6 col-sm-12 col-12 d-flx-mobile">
            <div class="text-right  footer-text-logo">
            <img class="LogoTXTW" src="../assets/icons/Group-7133.svg" alt="مركز الأعمال">	المركز السعودي للأعمال ©
              <span class="CurrentYear">2024</span>
            </div>
          </div>
          <div class="col-md-4 col-lg-6 col-sm-12 col-12 d-flx-mobile">
            <div class="text-left">
              <a href="https://sa.linkedin.com/company/saudi-business-center" target="_blank" title="linkedin" rel="noreferrer" class="btn-facebook social-media-icons"><i class="fa-brands fa-linkedin" aria-hidden="true"></i></a>
              <a href="https://www.youtube.com/channel/UC1mSbR2yfVqz6nn5sSBYa9g" target="_blank" title="youtube" rel="noreferrer" class="btn-youtube social-media-icons"><i class="fa-brands fa-youtube" aria-hidden="true"></i></a>
              <a href="https://twitter.com/BCgov_sa?s=20" target="_blank" title="الحساب الرئيسي" rel="noreferrer" class="btn-twitter social-media-icons"><i class="fa-brands fa-twitter" aria-hidden="true"></i></a>
              <a href="https://www.instagram.com/saudi_business_center?utm_medium=copy_link" target="_blank" title="instagram" rel="noreferrer" class="btn-instagram social-media-icons"><i class="fa-brands fa-instagram" aria-hidden="true"></i></a>
            </div>
          </div>
          
          
        </div>
    </div>
  </div>	
</footer>
